import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var ListingsIcon = function ListingsIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d, _e;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height,
    fillColor = _props.fillColor;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, h("g", {
    fill: fillColor,
    stroke: "".concat((_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : "#222"),
    "stroke-linecap": "".concat((_d = attrs["stroke-linecap"]) !== null && _d !== void 0 ? _d : "round"),
    "stroke-width": "".concat((_e = attrs["stroke-width"]) !== null && _e !== void 0 ? _e : "1.3")
  }, [h("path", {
    // eslint-disable-next-line max-len
    d: "M11.2991 14C11.2398 14 11.1813 13.9815 11.1253 13.9449L8.20053 12.0381C7.99054 11.9012 7.7483 11.8288 7.5 11.8288C7.2517 11.8288 7.00946 11.9012 6.79947 12.0381L3.8747 13.9449C3.81867 13.9815 3.76017 14 3.70084 14C3.60233 14 3.50134 13.9478 3.43725 13.8638C3.39423 13.8074 3.34947 13.7122 3.3805 13.5789L4.21096 10.0127C4.32652 9.5165 4.16585 9.00128 3.79166 8.66811L1.11523 6.28507C0.965399 6.15166 0.997158 5.98687 1.01777 5.9222C1.03837 5.85754 1.1076 5.70549 1.30482 5.69015L4.77119 5.42047C5.2665 5.38193 5.70604 5.04927 5.89095 4.57296L7.19542 1.21284C7.26999 1.02074 7.43327 1 7.5 1C7.56673 1 7.73 1.02074 7.80458 1.21284L9.10904 4.57296C9.29396 5.04927 9.7335 5.38193 10.2288 5.42047L13.6952 5.69015C13.8924 5.70549 13.9616 5.85755 13.9822 5.9222C14.0028 5.98687 14.0346 6.15167 13.8848 6.28508L11.2083 8.6681C10.8342 9.00128 10.6735 9.5165 10.789 10.0127L11.6195 13.5789C11.6505 13.7121 11.6058 13.8073 11.5627 13.8637C11.4986 13.9478 11.3976 14 11.2991 14Z"
  })]));
};